"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
exports.__esModule = true;
exports.default = exports.StyledImage = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _orbitDesignTokens = require("@kiwicom/orbit-design-tokens");
var _defaultTheme = _interopRequireDefault(require("../defaultTheme"));
var _consts = require("./consts");
const getSizeToken = name => ({
  theme,
  size
}) => {
  const tokens = {
    [_consts.TOKENS.WIDTH]: {
      [_consts.SIZES.SMALL]: "16px",
      [_consts.SIZES.MEDIUM]: theme.orbit.widthCountryFlag
    },
    [_consts.TOKENS.HEIGHT]: {
      [_consts.SIZES.SMALL]: "9px",
      [_consts.SIZES.MEDIUM]: "13px"
    }
  };
  return tokens[name][size];
};
const StyledCountryFlag = _styledComponents.default.div.withConfig({
  displayName: "CountryFlag__StyledCountryFlag",
  componentId: "sc-m27t9u-0"
})(["position:relative;height:", ";width:", ";background-color:", ";border-radius:", ";overflow:hidden;flex-shrink:0;"], getSizeToken(_consts.TOKENS.HEIGHT), getSizeToken(_consts.TOKENS.WIDTH), ({
  theme
}) => theme.orbit.backgroundCountryFlag, ({
  theme
}) => theme.orbit.borderRadiusSmall);
StyledCountryFlag.defaultProps = {
  theme: _defaultTheme.default
};
const StyledImage = _styledComponents.default.img.attrs(({
  theme,
  size,
  code
}) => {
  const width = parseInt(getSizeToken(_consts.TOKENS.WIDTH)({
    theme,
    size
  }), 10);
  return {
    src: `${_consts.baseURL}/flags/${width}x0/flag-${code.toLowerCase()}.jpg`,
    srcSet: `${_consts.baseURL}/flags/${width * 2}x0/flag-${code.toLowerCase()}.jpg 2x`
  };
}).withConfig({
  displayName: "CountryFlag__StyledImage",
  componentId: "sc-m27t9u-1"
})(["display:block;height:100%;width:100%;flex-shrink:0;"]);
exports.StyledImage = StyledImage;
StyledImage.defaultProps = {
  theme: _defaultTheme.default
};
const StyledShadow = _styledComponents.default.div.withConfig({
  displayName: "CountryFlag__StyledShadow",
  componentId: "sc-m27t9u-2"
})(["position:absolute;display:block;height:100%;width:100%;top:0;right:0;bottom:0;left:0;box-shadow:inset 0 0 0 1px ", ";border-radius:", ";"], ({
  theme
}) => (0, _orbitDesignTokens.convertHexToRgba)(theme.orbit.paletteInkDark, 10), ({
  theme
}) => theme.orbit.borderRadiusSmall);
StyledShadow.defaultProps = {
  theme: _defaultTheme.default
};
function getCountryProps(code, name) {
  const codeNormalized = code ? code.toUpperCase().replace("-", "_") : "UNDEFINED";
  const countryCodeExists = (codeNormalized in _consts.CODES);
  if (!countryCodeExists) console.warn(`Country code not supported: ${code}`);
  const countryCode = countryCodeExists ? _consts.CODES[codeNormalized] : _consts.CODES.UNDEFINED;
  const countryName = countryCode === _consts.CODES.UNDEFINED && !name ? "Undefined" : name;
  return {
    code: countryCode,
    name: countryName
  };
}
const CountryFlag = ({
  dataTest,
  size = _consts.SIZES.MEDIUM,
  id,
  ...props
}) => {
  const {
    code,
    name
  } = getCountryProps(props.code, props.name);
  return /*#__PURE__*/_react.default.createElement(StyledCountryFlag, {
    size: size
  }, /*#__PURE__*/_react.default.createElement(StyledImage, {
    key: code,
    alt: name,
    title: name,
    code: code,
    id: id,
    "data-test": dataTest,
    size: size
  }), /*#__PURE__*/_react.default.createElement(StyledShadow, null));
};
var _default = CountryFlag;
exports.default = _default;